import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  personButtonContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  title: {
    fontSize: 20,
    marginBottom: 16,
    color: theme.palette.blue.efesDarkBlue,
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },
  description: {
    color: theme.palette.gray.inputPlaceholder,
    fontSize: '1rem',
    marginBottom: 16,
  },
  mainButton: {
    borderRadius: 6,
    textTransform: 'capitalize',
    background: theme.palette.white.main,
    borderColor: theme.palette.gray.efesBorder,
    height: 46,
    width: 'fit-content',
    marginRight: 20,
    marginBottom: 20,
  },
  active: {
    backgroundColor: theme.palette.primary.pressed,
    '&:hover': {
      backgroundColor: theme.palette.primary.pressed,
      color: theme.palette.white.main,
    },
  },
}));

export default useStyles;
